var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1rem",
    height: "1rem",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1175 1.24717C15.3544 1.48403 15.5423 1.76524 15.6705 2.07473C15.7987 2.38422 15.8647 2.71593 15.8647 3.05092C15.8647 3.38591 15.7987 3.71762 15.6705 4.02711C15.5423 4.3366 15.3544 4.6178 15.1175 4.85467L5.69601 14.2755C5.28733 14.6841 4.77529 14.974 4.21462 15.1141L1.29265 15.8449C1.18578 15.8717 1.0738 15.8703 0.967617 15.8409C0.861438 15.8115 0.764682 15.7551 0.68678 15.6772C0.608878 15.5993 0.552486 15.5026 0.523102 15.3964C0.493717 15.2902 0.492341 15.1782 0.519109 15.0714L1.24992 12.1494C1.39003 11.5887 1.67989 11.0767 2.0885 10.668L11.51 1.24717C11.7468 1.01029 12.0281 0.822382 12.3375 0.694183C12.647 0.565983 12.9787 0.5 13.3137 0.5C13.6487 0.5 13.9804 0.565983 14.2899 0.694183C14.5994 0.822382 14.8806 1.01029 15.1175 1.24717ZM10.6083 3.95359L2.99086 11.5697C2.74567 11.815 2.57176 12.1222 2.48771 12.4587L2.01517 14.3495L3.90597 13.8769C4.24248 13.7927 4.54976 13.6186 4.79493 13.3732L12.4111 5.75703L10.6076 3.95359H10.6083ZM12.4111 2.14888L11.5093 3.05124L13.3128 4.85467L14.2158 3.95295C14.455 3.71364 14.5894 3.38908 14.5893 3.05069C14.5893 2.7123 14.4548 2.3878 14.2154 2.14856C13.9761 1.90933 13.6516 1.77496 13.3132 1.77502C12.9748 1.77508 12.6503 1.90956 12.4111 2.14888Z",
    fill: "#5796B9"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.814f9493c8debad6b79f358ab29e424a.svg";
export { ForwardRef as ReactComponent };